import {
  DEFAULT_ANCHOR_BY_TYPE,
  DEFAULT_THICKNESS,
  ElementState,
  ElementType,
  Group,
} from '@ritabygglov/core';

export const createGroup = (
  x: number,
  y: number,
  width: number,
  height: number,
  childIds: string[],
  renderingOrder: number,
  id: string,
  userId: string
): Group => {
  return {
    type: ElementType.Group,
    x,
    y,
    width,
    height,
    childIds,
    state: ElementState.Visible,
    rotate: 0,
    renderingOrder,
    text: '',
    userVersion: {
      userId,
      version: 1,
    },
    showDimensions: false,
    // Inert on a Group — it renders no stroke of its own — but ElementBase
    // requires both, and they must round-trip through persistence.
    thickness: DEFAULT_THICKNESS,
    thicknessAnchor: DEFAULT_ANCHOR_BY_TYPE[ElementType.Group],
    id,
  };
};
